export default __webpack_public_path__ + "static/media/us.ad434243.jpg";